// The way to the money screen from a unit's money line — one button, no explanation.
//
// WHY THE LISTS ON THOSE SCREENS ARE READ-ONLY. Recording a charge and recording a payment
// used to be possible from three places, each with its own dialog and its own idea of what
// a charge was. One screen owns that now; the retainer and job screens keep the RECORD,
// and this button is how you get to where it is written.
import { useNavigate } from 'react-router-dom';
import he from '../i18n/he';
import Button from './Button';

export default function MoneyScreenNote() {
  const navigate = useNavigate();
  return (
    <Button small variant="subtle" onClick={() => navigate('/money')}>
      {he.collections.board.goToMoney}
    </Button>
  );
}
